
import { Component, Input, OnInit } from '@angular/core';

import { CustomFormFieldSubmission } from '@core/objects/form';

@Component({
    selector: 'form-field-view-url-text-v1',
    templateUrl: './view-url-text-v1.component.html'
})
export class ViewUrlTextV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;

    ngOnInit(): void {
    }

}